import React, { Component } from "react";
import ViewsTable from "../../../../components/tables/ViewsTable";
import FieldModal from "../../../../components/modals/fieldModal";
import InputField from "../../../../components/inputs/inputField";
import { UncontrolledTooltip } from 'reactstrap';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';

const submissionTypes = {
    checkInForm: "eventCheckin",
    walkInForm: "walkInCheckin",
    sessionCheckInForm: "sessionCheckin",
}

class FormSubmissionsModal extends Component {
    constructor(props) {
        let columns = {
            email: "Email",
            firstName: "First Name",
            lastName: "Last Name",
            submittedAt: "Submitted",
            source: "Source",
        };


        let columnTypes = {
            email: "text",
            firstName: "text",
            lastName: "text",
            submittedAt: "timestamp",
            source: "text",
        };

        if (props.formType === "sessionCheckInForm") {
            columns.selectedSession = "Session";
            columnTypes.selectedSession = "text";
        }


        const toggledColumns = {};
        let normalizedColumns = Object.keys(columns).map((cfc) => {
            toggledColumns[cfc] = true;
            return {
                label: columns[cfc],
                key: cfc,
                value: cfc,
                type: columnTypes[cfc],
                sortAsc: false,
                sortDesc: false,
            };
        });

        const toggledFieldLabels = { ...toggledColumns };
        const normalizedFieldLabels = [...normalizedColumns];
        props.form.pages.forEach((page) => {
            page.sections.forEach((section) => {
                section.fields.forEach((field) => {
                    toggledFieldLabels[field.id] = true;
                    normalizedFieldLabels.push({
                        key: field.id,
                        label: field.label,
                        type: field.type,
                        value: field.id,
                        sortAsc: false,
                        sortDesc: false,
                    });

                    if (field.type == "nestedSections") {
                        field.nestedSections.forEach((nestedSection) => {
                            nestedSection.questions.forEach((question) => {
                                toggledFieldLabels[question.id] = true;
                                normalizedFieldLabels.push({
                                    key: question.id,
                                    label: question.label,
                                    type: question.type,
                                    value: question.id,
                                    sortAsc: false,
                                    sortDesc: false,
                                });
                            });
                        });
                    }
                });
            });
        });

        props.event.customFields.attendees.forEach((cfcategory) => {
            cfcategory.fields.forEach((field) => {
                columns[field._id] = field.fieldName;
                columnTypes[field._id] = field.fieldType;
                toggledColumns[field._id] = true;

                let attendeeCustomField = {
                    label: field.fieldName,
                    key: field._id,
                    value: field._id,
                    type: field.fieldType,
                    sortAsc: false,
                    sortDesc: false,
                };
                normalizedColumns.push(attendeeCustomField);
            });
        });

        super(props);
        this.state = {
            loading: false,
            columns: columns,
            columnTypes: columnTypes,
            normalizedColumns: normalizedColumns,
            toggledColumns: toggledColumns,
            normalizedFieldLabels: normalizedFieldLabels,
            toggledFieldLabels: toggledFieldLabels,
            checkedSubmission: {},
            submissionDetailsModalTrigger: false,
            selectedColumnSort: null,
            sortDesc: false,
            searchTerm: "",
            searching: false,
        };
    }

    componentDidMount() {
        const { columnTypes, columns } = this.state;
        const { form, formType, event } = this.props;
        let customFieldColumns = [];
        let customFieldColumnTypes = [];
        event.customFields.attendees.forEach((category) => {
            category.fields.forEach((f) => {
                customFieldColumns[f._id] = f.fieldName;
                customFieldColumnTypes[f._id] = f.fieldType;
            });
        });
        let att = form.submissions.map((a) => {
            if (a.formData.submissionType && a.formData.submissionType === submissionTypes[formType] && !a.deleted) {

                let extraFields =
                    typeof a.formData.extraFields == "string"
                        ? JSON.parse(a.formData.extraFields)
                        : a.formData.extraFields;
                const sub = {
                    _id: a._id,
                    firstName:
                        a.attendee.firstName === "-"
                            ? a.formData.firstName || "-"
                            : a.attendee.firstName,
                    lastName:
                        a.attendee.lastName === "-"
                            ? a.formData.lastName || "-"
                            : a.attendee.lastName,
                    email:
                        a.attendee.email === "-" ? a.formData.email || "-" : a.attendee.email,
                    submittedAt: a.submittedAt,
                    source: form.name,
                    ...extraFields,
                    ...a.formData,
                };


                if (this.props.formType === "sessionCheckInForm") {
                    const session = event.sessions.find((s) => s._id === a.formData.selectedSession);
                    sub.selectedSession = session ? session.name : "";
                }

                return sub;
            }

            return null
        }).filter((a) => a != null);

        this.setState({
            loading: false,
            formSubmissions: att,
            columns: { ...columns, ...customFieldColumns },
            columnTypes: { ...columnTypes, ...customFieldColumnTypes },
        });
    }

    sortData = (column, sortAsc, sortDesc) => {
        const { normalizedColumns } = this.state;
        const updatedColumns = normalizedColumns.map((col) => {
            if (col.key == column.key) {
                col.sortAsc = sortAsc;
                col.sortDesc = sortDesc;
            } else {
                col.sortAsc = false;
                col.sortDesc = false;
            }
            return col;
        });

        this.setState({
            normalizedColumns: updatedColumns,
            selectedColumnSort: column,
            sortDesc: sortDesc ? true : false,
        });
    };
    searchEntries = (searchText) => {
        this.setState({
            searching: searchText != "" ? true : false,
            searchText: searchText ? searchText : "",
        });
    };
    s2ab = (s) => {
		var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
		var view = new Uint8Array(buf); //create uint8array as viewer
		for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
		return buf;
	};
    download = (attList) => {
        const columns = this.state.normalizedFieldLabels.reduce((acc, cur) => {
            acc[cur.key] = cur.label;
            return acc;
        }, {});
            const headers = Object.values(columns);
            const rows = attList.map(sub => {
                return Object.keys(columns).map(key => {
                    if (key === 'submittedAt' && sub[key]) {
                        return moment(sub[key]).format('MM/DD/YYYY h:mm a');
                    }
                    return (sub[key] || sub[key] === '') ? sub[key] : '';
                });
            });

        var wb = XLSX.utils.book_new();
        wb.Props = {
            Title:'Form Submission',
            Subject: 'Submissions',
            Author: 'Simple Events',
            CreatedDate: new Date()
        };
        wb.SheetNames.push('Data');
        /* make worksheet */
        var ws_data2 = [headers, ...rows];
        var ws2 = XLSX.utils.aoa_to_sheet(ws_data2);

        /* Add the worksheet to the workbook */
        wb.Sheets['Data'] = ws2;

        var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

        saveAs(
            new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
           `${this.props.form.name} Submissions.xlsx`
        );
    };

    render() {
        const { isOpen, form } = this.props;

        const {
            normalizedFieldLabels,
            toggledFieldLabels,
            searchTerm,
            formSubmissions,
        } = this.state;

        return (
            <FieldModal
                isFullWidthBody={true}
                size="large"
                modalTitle={`Form Submissions`}
                isOpen={isOpen}
                bodyDescription={""}
                bodyContent={() => {
                    return (
                        <div className="h-100">
                            <div className="actionButtonContainer  flex-ac">
                                {/* Search filed */}

                                <div className="mb-10  mt-10 flex aic">
                                    <InputField
                                        classes="m-0 viewSearch"
                                        placeholder="Search "
                                        clickIcon={true}
                                        required={true}
                                        value={searchTerm}
                                        onChange={(e) => {
                                            clearTimeout(this.searchTimeout);
                                            this.setState({ searchTerm: e.target.value }, () => {
                                                this.searchTimeout = setTimeout(
                                                    () => this.searchEntries(this.state.searchTerm),
                                                    1000
                                                );
                                            });
                                        }}
                                        prefix={
                                            <i
                                                className="las la-search"
                                                style={{ marginRight: 5, transform: "rotate(270deg)" }}
                                            />
                                        }
                                        inputIcon={
                                            searchTerm != "" && (
                                                <i
                                                    onMouseDown={() =>
                                                        this.setState(
                                                            { searchTerm: "", searching: false },
                                                            () => this.searchEntries("")
                                                        )
                                                    }
                                                    //onClick={() => this.setState({ searchTerm: '', searching: false })}
                                                    className="las la-times-circle"
                                                    style={{
                                                        visibility: searchTerm == "" ? "hidden" : "visible",
                                                    }}
                                                />
                                            )
                                        }
                                    />
                                </div>
                                <div className="sectionOptionsContainer">
                                    <div id="downloadTable" className='c-pointer fs-20' onClick={() => this.download(formSubmissions)}>
                                        <i className="las la-download" />
                                        <UncontrolledTooltip target="downloadTable" placement="left">Download Table Data</UncontrolledTooltip>
                                    </div>
                                </div>
                            </div>
                        
                            <ViewsTable
                                title={"Submissions"}
                                style={{ margin: 0 }}
                                noDescription={true}
                                columns={normalizedFieldLabels}
                                toggledColumns={toggledFieldLabels}
                                data={formSubmissions || []}
                                mainColumnActive={false}
                                disableCheck={true}
                                sortData={this.sortData}
                                checked={{}}
                            />
                        </div>
                    );
                }}
                toggle={this.props.toggle}
                cancelButtonLabel={"Close"}
            ></FieldModal>
        );
    }
}

export default FormSubmissionsModal;
